import { MenuOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";

const FactoryHeader = ({ onToggleGuide, isSiderVisible, styles }) => (
    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
        <Col flex="auto" style={{ textAlign: "center" }}>
            <span style={styles.headerText}>Fábrica de Agente</span>
        </Col>
        <Col>
            <Button
                type="primary"
                icon={<MenuOutlined />}
                onClick={onToggleGuide}
            >
                {isSiderVisible ? "Ocultar guía" : "Mostrar guía"}
            </Button>
        </Col>
    </Row>
);

export default FactoryHeader;